"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

var _default = function _default(_ref) {
  var centerHeaders = _ref.centerHeaders,
      imageSize = _ref.imageSize,
      itemsPerRow = _ref.itemsPerRow,
      sectionItems = _ref.sectionItems,
      sectionTitle = _ref.sectionTitle,
      sectionDescription = _ref.sectionDescription;
  return _react["default"].createElement(_semanticUiReact.Container, {
    style: {
      margin: '0 0 2.5rem 0'
    },
    id: sectionTitle
  }, _react["default"].createElement(_semanticUiReact.Header, {
    as: "h2",
    textAlign: centerHeaders ? 'center' : 'left'
  }, sectionTitle), _react["default"].createElement(_semanticUiReact.Header, {
    as: "h4",
    textAlign: centerHeaders ? 'center' : 'left'
  }, sectionDescription), _react["default"].createElement(_semanticUiReact.Grid, {
    columns: itemsPerRow,
    stackable: true
  }, sectionItems.map(function (item) {
    return _react["default"].createElement(_semanticUiReact.Grid.Column, {
      key: item.itemTitle
    }, _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, item, {
      imageSize: imageSize
    })));
  })));
};

exports["default"] = _default;